import{m as a}from"./chunk-HBP5N4FR.js";a();var s=({transactions:n,isGuarded:r})=>r?n.every(e=>Boolean(e.getGuardianSignature().toString("hex"))):!0;export{s as a};
//# sourceMappingURL=chunk-UUYNGUKK.js.map
